module.exports = __webpack_public_path__ + "4c6f44b18e169d3da4bb32d7599b581f.m4v";